import gql from 'graphql-tag'
export default gql`mutation deleteAttestMutation($attestId: Int!) {
  deleteAttest(attestId: $attestId) {
    success
  }
}`